import { useState, useEffect } from "react";
import "../styles/sidebar.css";
import { sidebarItems } from "./sidebarItems";
import { useAuth } from "../context/AuthContext";
import { Link, useLocation } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CloseIcon from "@mui/icons-material/Close";
import { useSidebar } from "../context/SidebarContext";
import logo from "../image/beejpoorti.jpg";
import smllogo from "../image/tree.jpg";

const Sidebar = () => {
  const { user } = useAuth();
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();
  const { isOpen, toggleSidebar } = useSidebar();

  const currentUser = user;
  const userRole = (currentUser?.user_role || "").toLowerCase();

  const toggleDropdown = (menu) => {
    setOpenDropdown((prev) => (prev === menu ? null : menu));
  };

  const visibleItems = sidebarItems.filter((item) => {
    const roleMatch = item.roles?.some((role) => role.toLowerCase() === userRole);
    const profileStatusMatch = !item.profileStatus || user?.profile_status === item.profileStatus;
    return roleMatch && profileStatusMatch;
  });

  useEffect(() => {
    const matchedItem = visibleItems.find(
      (item) =>
        item.submenus &&
        item.submenus.some((sub) =>
          location.pathname.replace(/\/$/, "").startsWith(sub.path)
        )
    );
    if (matchedItem) {
      setOpenDropdown(matchedItem.title);
    }
  }, [location.pathname, visibleItems]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992 && !isOpen) {
        toggleSidebar();
      } else if (window.innerWidth < 992 && isOpen) {
        toggleSidebar();
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isOpen, toggleSidebar]);

  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <nav className="sidebar-nav ps ps--active-y">
        <div className="tpicncls justify-content-lg-between">
          <img src={logo} className="fsticn" alt="Logo" />
          <img src={smllogo} className="fsticn sml" alt="Logo" />
          <button
            className="navbar-toggler sidebar-toggler d-lg-none sidebarcls"
            type="button"
            onClick={toggleSidebar}
          >
            <CloseIcon />
          </button>
        </div>

        <ul className="nav">
          {/* {console.log("visibleItems", visibleItems)} */}
          {visibleItems.map((item, index) => {
            const hasSubmenu =
              Array.isArray(item.submenus) && item.submenus.length > 0;

            //  Normalize paths to avoid trailing slash mismatches
            const currentPath = location.pathname.replace(/\/$/, "");

            const isParentActive =
              hasSubmenu &&
              item.submenus.some((sub) =>
                currentPath.startsWith(sub.path.replace(/\/$/, ""))
              );

            const isSingleActive =
              !hasSubmenu &&
              currentPath.startsWith(item.path?.replace(/\/$/, ""));

            return (
              <li
                key={index}
                className={`nav-item ${
                  isParentActive || isSingleActive ? "active" : ""
                }`}
              >
                {hasSubmenu ? (
                  <>
                    <button
                      type="button"
                      className="nav-link btn-toggle d-flex align-items-center justify-content-between"
                      onClick={() => toggleDropdown(item.title)}
                      aria-expanded={openDropdown === item.title}
                      aria-controls={`${item.title}-submenu`}
                    >
                      <span className="d-flex align-items-center ms-0">
                        <img
                          src={item.icon}
                          style={{ width: "24px" }}
                          alt={`item-${item.icon}`}
                        />
                        <span className="text-start">{item.title}</span>
                      </span>

                      {openDropdown === item.title ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )}
                    </button>

                    {/* Dropdown menu */}
                    {openDropdown === item.title && (
                      <ul
                        className="nav-dropdown-items"
                        id={`${item.title}-submenu`}
                        role="region"
                      >
                        {item.submenus.map((sub, subIndex) => {
                          const isSubActive = currentPath.startsWith(
                            sub.path.replace(/\/$/, "")
                          );
                          return (
                            <li
                              key={subIndex}
                              className={`nav-item ${
                                isSubActive ? "active" : ""
                              }`}
                            >
                              <Link className="nav-link" to={sub.path}>
                                {sub.title}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </>
                ) : (
                  <Link
                    className={`nav-link d-flex align-items-center`}
                    to={item.path}
                  >
                    <img
                      src={item.icon}
                      style={{ width: "24px" }}
                      alt={`item-${item.icon}`}
                    />
                    <span style={{ marginLeft: "8px" }}>{item.title}</span>
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
